<div class="signature-container">
  <canvas #canvas width="400" height="200" 
          [style.border]="isLocked ? '1px solid #ccc' : '1px solid #000'"
          [style.background]="isLocked ? '#f5f5f5' : '#fff'">
  </canvas>
  
  <div class="actions">
    <button mat-flat-button class="clear-btn metallic-text-btn" (click)="clear()" type="button">
      <mat-icon>clear</mat-icon>
      Clear
    </button>
    
    <button *ngIf="!isLocked" mat-flat-button class="confirm-btn metallic-text-btn-blue" type="button" (click)="save()">
      <mat-icon>check</mat-icon>
      Confirm Signature
    </button>

    <button *ngIf="isLocked" mat-flat-button class="edit-btn metallic-text-btn-green" type="button" (click)="unlock()">
      <mat-icon>edit</mat-icon>
      Edit Signature
    </button>
  </div>
</div>

<!-- <div class="signature-container">
  <canvas #canvas width="400" height="200" style="border: 1px solid #000; background: #fff;"></canvas>
  
  <div class="actions">
    <button mat-flat-button color="warn" (click)="clear()">Clear</button>
    <button mat-flat-button color="primary" (click)="save()">Confirm Signature</button>
  </div>
</div> -->